<template>
  <div>
    <a ref="lienDownload"></a>
    <div class="card modal-card-border infoWindowMap">
      <div class="card-content">
        <div :key="index" v-for="(reseau, index) in marker.reseaux"
             v-if="index === marker.indexReseauCourant" >
          <div>
            <div class="columns">
              <div class="column is-1">
                <a  @click="precedent()"
                    v-bind:class="{disabled: !peutAllerPrecedent() }">
                  <b-icon icon="chevron-left" class="arrow" size="is-large"></b-icon>
                </a>
              </div>
              <div class="column">
                <div class="level is-marginless">
                  <div class="level-left">
                    <div class="information-title">
                      <h2 class="subtitle is-5">
                        {{marker.reseaux.length}} réseau(x)
                      </h2>
                      <h1 class="title is-6">{{reseau.libelle}}</h1>
                    </div>
                  </div>
                  <div class="level-right">
                  </div>
                </div>
                <div class="detail-component">
                  <br>
                  <h1 class="subtitle is-6 information-title">Informations</h1>
                  <div class="columns">
                    <div class="column is-4">
                      <p class="information">Code réseau</p>
                      <span>{{reseau.code}}</span>
                    </div>
                    <div class="column is-4">
                      <p class="information">Nombre de faces</p>
                      <span>{{reseau.nbFaces}}</span>
                    </div>
                    <div class="column is-4">
                      <p class="information">Tarif brut</p>
                      <span>{{reseau.tarifBrut}}</span>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-4">
                      <p class="information">Ville</p>
                      <span>{{reseau.ville}}</span>
                    </div>
                    <div class="column is-4">
                      <p class="information" v-if="reseau.format">Format</p>
                      <span v-if="reseau.format">{{reseau.format}}</span>
                    </div>
                    <div class="column is-4">
                      <p class="information">Jour de départ</p>
                      <span>{{reseau.jourDepart}}</span>
                    </div>
                  </div>
                  <div class="columns">
                    <div class="column is-4">
                      <p class="information">Délai de conservation</p>
                      <span>{{reseau.dureeConservation}} </span>
                    </div>
                    <div class="column is-4">
                      <p class="information" v-if="reseau.confrere">Confrère</p>
                      <span v-if="reseau.confrere">{{reseau.confrere}}</span>
                    </div>
                    <div class="column is-4">
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-1">
                <a  @click="suivant()"
                    v-bind:class="{disabled: !peutAllerSuivant() }">
                  <b-icon icon="chevron-right" class="arrow" size="is-large"></b-icon>
                </a>
              </div>
            </div>
            <div>
              <button class="button is-primary button-modal-detail">
                <b-icon icon="cart-plus"></b-icon><p>Ajouter au panier</p>
              </button>
              <button class="button is-primary button-modal-detail"
                      @click="zoomReseau(marker)">
                <b-icon icon="magnify-plus"></b-icon><p>Zoom</p>
              </button>
              <button class="button is-primary button-modal-detail"
                      @click="ouvrirDiaporama(reseau)">
                <b-icon icon="image-multiple"></b-icon><p>Diaporama</p>
              </button>
              <button class="button is-primary button-modal-detail"
                     @click="download(reseau)">
                <b-icon icon="file-pdf"></b-icon><p>Télécharger la fiche produit</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as typesModal from '@/store/creationOpportunite/modal-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';
import { getFicheReseauxNumerique } from '@/api/reseauxNumerique';

const VenteReseauxNumerique = createNamespacedHelpers('venteReseauxNumerique');
const Modal = createNamespacedHelpers('modal');

export default {
  name: 'info-window-map',
  props: ['marker', 'centre', 'nbFacesRestantes', 'dataProposition'],
  data() {
    return {
      infoAffiche: false,
      produitSelect: {},
    };
  },
  watch: {
    marker() {
      this.infoAffiche = false;
      if (!this.marker) {
        return;
      }
      if (this.marker) {
        this.infoAffiche = true;
      }
    },
  },
  computed: {
    ...VenteReseauxNumerique.mapGetters({
      reseauxWithFilter: 'reseauxWithFilter',
      dateDeVisualisation: 'dateDeVisualisation',
    }),
    ...Modal.mapGetters({
      getIsComponentDiaporama: 'isComponentDiaporama',
      getFacesReseauSelect: 'facesSelectDiapo',
    }),
    facesReseauSelectDiapo: {
      get() {
        return this.getFacesReseauSelect;
      },
      set(value) {
        this.setFacesReseauSelect(value);
      },
    },
    isComponentDiaporama: {
      get() {
        return this.getIsComponentDiaporama;
      },
      set(value) {
        this.setIsComponentDiaporama(value);
      },
    },
  },
  methods: {
    ...Modal.mapMutations({
      setIsComponentDiaporama: typesModal.SET_IS_COMPONENT_DIAPORAMA,
      setFacesReseauSelect: typesModal.SET_FACES_SELECT_DIAPO,
    }),
    precedent() {
      if (this.peutAllerPrecedent()) {
        this.marker.indexReseauCourant = this.marker.indexReseauCourant - 1;
      }
    },
    suivant() {
      if (this.peutAllerSuivant()) {
        this.marker.indexReseauCourant = this.marker.indexReseauCourant + 1;
      }
    },
    peutAllerPrecedent() {
      return this.marker.indexReseauCourant !== 0;
    },
    peutAllerSuivant() {
      return this.marker.indexReseauCourant + 1 < this.marker.reseaux.length;
    },
    zoomReseau() {
      this.$emit('zoomReseau');
      this.$parent.close();
    },
    ouvrirDiaporama(reseau) {
      const newReseau = this.reseauxWithFilter.find((el) => {
        return el.num === reseau.num;
      });
      newReseau.listeFaces.forEach((el) => {
        el.libelleReseau = reseau.libelle;
      });
      this.facesReseauSelectDiapo = newReseau.listeFaces;
      this.isComponentDiaporama = true;
    },
    async download(data) {
      const produit = this.reseauxWithFilter.find(res => res.num === data.num);
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const response = await getFicheReseauxNumerique(produit);
        const link = this.$refs.lienDownload;
        link.href = window.URL.createObjectURL(response.data);
        const disposition = response.request.getResponseHeader('Content-Disposition');
        link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
        link.click();
      } catch (e) {
        gestionErreur(`Erreur lors de l'impression de la fiche du réseau Numérique  n°${produit.num}`, e);
      }
      loadingComponent.close();
    },
  },
};
</script>

<style scoped>
  .columns{
    margin:0px;
  }

  .mdi-chevron-right, .mdi-chevron-left{
    margin-left : 0px;
    margin-right : 0px;
    margin-top : 50px;
  }

  .bouton {
    margin-right: 10px;
  }

  .information {
    font-size:14px;
  }

  .information-title {
    margin-left:10px;
    margin-bottom:0;
  }

  .arrow {
    height: 30vh;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxNumerique/recherche/cartographie/infoWindowMapReseaux.vue